import './core/polyfills'

import bootstrapper from './setup/NordLockBootstrapper'

if (process.env.NODE_ENV === 'development') {
  window.bootstrapper = bootstrapper
}

bootstrapper.start()
